(() => {
  'use strict';
  const Core = {
    passedPurchaseArea(bottom, scrollY, documentHeight, viewportHeight) {
      if (Number.isFinite(bottom) && bottom < 0) return true;
      return scrollY >= 240 && scrollY / Math.max(1, documentHeight - viewportHeight) >= 0.3;
    },
    bottomOffset(top, height, viewportHeight) {
      return height > 0 && top < viewportHeight && top + height > 0 ? Math.max(12, viewportHeight - top + 12) : 12;
    }
  };
  if (typeof module !== 'undefined' && module.exports) { module.exports = Core; return; }
  if (customElements.get('rbnl-floating-winter-set')) return;
  class WinterSet extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = {signal:this.controller.signal};
      this.card = this.querySelector('[data-set-card]');
      this.pill = this.querySelector('[data-set-expand]');
      this.closeButton = this.querySelector('[data-set-collapse]');
      this.link = this.querySelector('[data-set-open]');
      if (!this.card || !this.pill || !this.link || !this.closeButton) return;
      this.shown = false;
      this.collapsed = this.remembered() || matchMedia('(max-width:749px)').matches;
      this.purchaseArea = document.querySelector('#main-content .product.js-product .js-product-form-main');
      this.closeButton.addEventListener('click',()=>this.collapse(true),options);
      this.pill.addEventListener('click',()=>{
        this.collapsed=false;
        this.remember(false);
        this.sync();
        this.closeButton.focus({preventScroll:true});
      },options);
      this.addEventListener('keydown',event=>{
        if (event.key==='Escape' && !this.collapsed) { event.preventDefault(); this.collapse(true); }
      },options);
      this.link.addEventListener('click',event=>{
        if (event.button!==0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || !window.RbnlQuickView?.open) return;
        event.preventDefault();
        this.collapse(false);
        window.RbnlQuickView.open(this,this.link.href,{focus:()=>{
          if (!this.isConnected) return;
          this.sync();
          if (!this.hidden) this.pill.focus({preventScroll:true});
        }});
        this.sync();
      },options);
      this.schedule=()=>{ if (!this.frame) this.frame=requestAnimationFrame(()=>{this.frame=0;this.sync();}); };
      window.addEventListener('scroll',this.schedule,{...options,passive:true});
      window.addEventListener('resize',this.schedule,{...options,passive:true});
      window.addEventListener('pageshow',this.schedule,options);
      document.addEventListener('shopify:section:unload',event=>{
        if(event.target===this || event.target?.contains(this))this.cleanup();
      },options);
      this.observer=new MutationObserver(records=>{
        if(records.some(record=>record.target===document.body || record.target.matches?.('cart-drawer,sticky-atc-panel,.rbnl-qv')))this.schedule();
      });
      this.observer.observe(document.body,{subtree:true,attributes:true,attributeFilter:['hidden','class','aria-hidden','open','style']});
      this.sync();
    }
    remembered() { try {return sessionStorage.getItem(this.dataset.storageKey)==='1';} catch {return false;} }
    remember(value) { try {sessionStorage.setItem(this.dataset.storageKey,value?'1':'0');} catch {} }
    visible(element) {
      if (!element || element.hidden || element.getAttribute('aria-hidden')==='true') return false;
      const style=getComputedStyle(element),rect=element.getBoundingClientRect();
      return style.display!=='none' && style.visibility!=='hidden' && Number(style.opacity)!==0 && rect.width>0 && rect.height>0 && rect.bottom>0 && rect.top<innerHeight && rect.right>0 && rect.left<innerWidth;
    }
    sync() {
      if (!this.controller || this.controller.signal.aborted) return;
      if (!this.shown && Core.passedPurchaseArea(this.purchaseArea?.getBoundingClientRect().bottom,scrollY,document.documentElement.scrollHeight,innerHeight))this.shown=true;
      const overlay=Boolean(document.querySelector('.rbnl-qv:not([hidden])')) || [...document.querySelectorAll('cart-drawer')].some(el=>el.getAttribute('aria-hidden')==='false' || this.visible(el));
      this.hidden=!this.shown || overlay;
      this.card.hidden=this.collapsed;
      this.pill.hidden=!this.collapsed;
      this.pill.setAttribute('aria-expanded',String(!this.collapsed));
      const sticky=[...document.querySelectorAll('sticky-atc-panel')].filter(el=>!el.classList.contains('sticky-atc-panel--out') && this.visible(el));
      const offset=sticky.reduce((max,el)=>{const rect=el.getBoundingClientRect();return Math.max(max,Core.bottomOffset(rect.top,rect.height,innerHeight));},12);
      const value=offset+'px';
      if(this.style.getPropertyValue('--rbws-bottom')!==value)this.style.setProperty('--rbws-bottom',value);
    }
    collapse(focus) {
      this.collapsed=true;
      this.remember(true);
      this.sync();
      if(focus && !this.hidden)this.pill.focus({preventScroll:true});
    }
    cleanup() {this.controller?.abort();this.observer?.disconnect();cancelAnimationFrame(this.frame);this.frame=0;this.controller=null;this.hidden=true;}
    disconnectedCallback() {this.cleanup();}
  }
  customElements.define('rbnl-floating-winter-set',WinterSet);
})();
